<template>
  <section class="calculator-section">
    <p class="calculator-description">
      Explore our full suite of free online statistics calculators—ideal for coursework,
      research, or data analysis. Each statistics calculator is accurate, easy to use,
      and comes with clear, step-by-step explanations.
    </p>
    <div v-animation class="calculator-list" data-animation="fade-in-up">
      <LinkCard
        v-for="calculator in calculators"
        :key="calculator.title"
        :title="calculator.title"
        :description="calculator.description"
        :link="calculator.link"
      />
    </div>
  </section>
</template>

<script>
import LinkCard from './LinkCard';

export default {
  components: {
    LinkCard,
  },
  data() {
    return {
      calculators: [
        {
          title: 'Student’s T Distribution t-table',
          description: 'Determine critical values for t-tests and confidence intervals—crucial for hypothesis testing with small sample sizes.',
          link: '/tables/students-t-distribution-table/',
        },
        {
          title: 'Standard Normal Distribution z-table ',
          description: 'Calculate the variance of a dataset to understand how data points are dispersed around the mean. This tool supports both sample and population variance—making it suitable for a wide range of statistical analyses.',
          link: '/tables/standard-normal-distribution-table/',
        },
        {
          title: 'F-Distribution Critical Values Table ',
          description: 'This population and sample standard deviation calculator helps you analyze data dispersion around the mean. Efficiently compute standard deviation for both sample and population datasets to support a wide range of statistical needs.',
          link: '/tables/f-distribution-table/',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.calculator-section {
  .calculator-description {
    color: var(--main-dark-shade-2);
    text-align: center;
    font-size: 21px;
    line-height: 110%;
    margin-bottom: 30px;
  }

  .calculator-list {
    display: grid;
    align-items: flex-start;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;
  }
}

@include bp($bp-mobile) {
  .calculator-section {
    .calculator-description {
      text-align: start;
      font-size: 18px;
    }

    .calculator-list {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }
}
</style>
